import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const mobileBackButton = (props) => (
    <button {...props} className={`u-size16x16 u-cursorPointer u-border0 u-flex justify-content-center align-items-center u-lineHeight1 u-backgroundColorTransparent`}>
        <span style={{transform: 'rotate(90deg)'}}>
            <FontAwesomeIcon icon="arrow-down" color="#333" size="lg" />
        </span>
    </button>
);

export default mobileBackButton;


// WEBPACK FOOTER //
// ./src/components/UI/Mobile/MobileBackButton/MobileBackButton.js